// File: src/pages/BudgetAndAlerts/BudgetEmptyState.tsx
// ==============================================
// NEW FILE
import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate, useOutletContext } from 'react-router-dom';

interface OutletContextType {
  userRole?: string | null;
}

const BudgetEmptyState: React.FC = () => {
  const { userRole } = useOutletContext<OutletContextType>();
  const navigate = useNavigate();

  const handleAddNewBudgetClick = () => {
    navigate('/budget-alerts/add');
  };

  return (
    <Box sx={{
      backgroundColor: 'white',
      borderRadius: '10px',
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
    }}>
      <Box
        component="img"
        src="/icons/No-data-src-added-log.svg"
        alt="No budgets"
        sx={{ width: '143px', height: '143px' }}
      />
      <Typography variant="h5" component="h1" sx={{ fontWeight: 600, fontSize: '16px', mt: '16px', mb: '12px', fontFamily: 'Inter', color: '#333333 ' }}>
        No Budgets or Alerts Found
      </Typography>
      <Typography variant="body1" sx={{ color: '#666666 ', fontFamily: 'Inter', fontWeight: 400, maxWidth: '480px', fontSize: '14px', mb: '16px' }}>
        Get started by creating a new budget to monitor your cloud spending.
      </Typography>
      {userRole !== 'viewer' && (
        <Button
          disableElevation
          variant="contained"
          onClick={handleAddNewBudgetClick}
          sx={{ fontFamily: 'Inter', backgroundColor: '#0064FF', fontSize: '14px', fontWeight: 500, borderRadius: '8px', textTransform: 'none' }}
        >
          Add New Budget
        </Button>
      )}
    </Box>
  );
};

export default BudgetEmptyState;